import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66111b90"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "/assets/img/logo-small.svg"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "caution-note"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("注意"),
    /*#__PURE__*/_createElementVNode("rt", null, "ちゅうい"),
    /*#__PURE__*/_createTextVNode("事項"),
    /*#__PURE__*/_createElementVNode("rt", null, "じこう")
  ])
], -1))
const _hoisted_5 = { class: "m-list" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p data-v-66111b90><ruby data-v-66111b90>練習問題<rt data-v-66111b90>れんしゅうもんだい</rt></ruby>を<ruby data-v-66111b90>良<rt data-v-66111b90>よ</rt></ruby>く<ruby data-v-66111b90>見<rt data-v-66111b90>み</rt></ruby>て<ruby data-v-66111b90>問題<rt data-v-66111b90>もんだい</rt></ruby>の<ruby data-v-66111b90>解<rt data-v-66111b90>と</rt></ruby>き<ruby data-v-66111b90>方<rt data-v-66111b90>かた</rt></ruby>と<ruby data-v-66111b90>答<rt data-v-66111b90>こた</rt></ruby>え<ruby data-v-66111b90>方<rt data-v-66111b90>かた</rt></ruby>をしっかり<ruby data-v-66111b90>覚<rt data-v-66111b90>おぼ</rt></ruby>えましょう。</p><p data-v-66111b90><ruby data-v-66111b90>答<rt data-v-66111b90>こた</rt></ruby>えが<ruby data-v-66111b90>分<rt data-v-66111b90>わ</rt></ruby>かったら、その<ruby data-v-66111b90>番号<rt data-v-66111b90>ばんごう</rt></ruby>の○を<ruby data-v-66111b90>押<rt data-v-66111b90>お</rt></ruby>してください。</p><p data-v-66111b90><ruby data-v-66111b90>間違<rt data-v-66111b90>まちが</rt></ruby>って<ruby data-v-66111b90>押<rt data-v-66111b90>お</rt></ruby>した<ruby data-v-66111b90>場合<rt data-v-66111b90>ばあい</rt></ruby>は、<ruby data-v-66111b90>正<rt data-v-66111b90>ただ</rt></ruby>しい<ruby data-v-66111b90>番号<rt data-v-66111b90>ばんごう</rt></ruby>の○を<ruby data-v-66111b90>押<rt data-v-66111b90>お</rt></ruby>しなおしてください。</p>", 3)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("終"),
  /*#__PURE__*/_createElementVNode("rt", null, "お")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("先生"),
  /*#__PURE__*/_createElementVNode("rt", null, "せんせい")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("言"),
  /*#__PURE__*/_createElementVNode("rt", null, "い")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("椅子"),
  /*#__PURE__*/_createElementVNode("rt", null, "いす")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("座"),
  /*#__PURE__*/_createElementVNode("rt", null, "すわ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("静"),
  /*#__PURE__*/_createElementVNode("rt", null, "しず")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("待"),
  /*#__PURE__*/_createElementVNode("rt", null, "ま")
], -1))
const _hoisted_17 = {
  key: 1,
  class: "caution-note"
}
const _hoisted_18 = { class: "m-list" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("今"),
  /*#__PURE__*/_createElementVNode("rt", null, "いま")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("級"),
  /*#__PURE__*/_createElementVNode("rt", null, "きゅう")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("始"),
  /*#__PURE__*/_createElementVNode("rt", null, "はじ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("聞"),
  /*#__PURE__*/_createElementVNode("rt", null, "き")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("読"),
  /*#__PURE__*/_createElementVNode("rt", null, "よ")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("聞"),
  /*#__PURE__*/_createElementVNode("rt", null, "き")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("読"),
  /*#__PURE__*/_createElementVNode("rt", null, "よ")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_42 = { key: 2 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("聞"),
  /*#__PURE__*/_createElementVNode("rt", null, "き")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("読"),
  /*#__PURE__*/_createElementVNode("rt", null, "よ")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_51 = { key: 3 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("聞"),
  /*#__PURE__*/_createElementVNode("rt", null, "き")
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("読"),
  /*#__PURE__*/_createElementVNode("rt", null, "よ")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_60 = { key: 4 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("英語"),
  /*#__PURE__*/_createElementVNode("rt", null, "えいご")
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("聞"),
  /*#__PURE__*/_createElementVNode("rt", null, "き")
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("答"),
  /*#__PURE__*/_createElementVNode("rt", null, "こた")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_65 = { key: 5 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("音声"),
  /*#__PURE__*/_createElementVNode("rt", null, "おんせい")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("正"),
  /*#__PURE__*/_createElementVNode("rt", null, "ただ")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("聞"),
  /*#__PURE__*/_createElementVNode("rt", null, "き")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("取"),
  /*#__PURE__*/_createElementVNode("rt", null, "と")
], -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("中"),
  /*#__PURE__*/_createElementVNode("rt", null, "ちゅう")
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("静"),
  /*#__PURE__*/_createElementVNode("rt", null, "しず")
], -1))
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<p data-v-66111b90></p><p data-v-66111b90>リスニング<ruby data-v-66111b90>問題<rt data-v-66111b90>もんだい</rt></ruby>では、<ruby data-v-66111b90>画面<rt data-v-66111b90>がめん</rt></ruby>の<ruby data-v-66111b90>問題<rt data-v-66111b90>もんだい</rt></ruby>は<ruby data-v-66111b90>音声<rt data-v-66111b90>おんせい</rt></ruby>に<ruby data-v-66111b90>合<rt data-v-66111b90>あ</rt></ruby>わせて、<ruby data-v-66111b90>自動<rt data-v-66111b90>じどう</rt></ruby>ですすみます。</p><p data-v-66111b90><ruby data-v-66111b90>答<rt data-v-66111b90>こた</rt></ruby>えがわかったら、その<ruby data-v-66111b90>番号<rt data-v-66111b90>ばんごう</rt></ruby>の○を<ruby data-v-66111b90>押<rt data-v-66111b90>お</rt></ruby>してください。</p><p data-v-66111b90><ruby data-v-66111b90>間違<rt data-v-66111b90>まちが</rt></ruby>って<ruby data-v-66111b90>押<rt data-v-66111b90>お</rt></ruby>した<ruby data-v-66111b90>場合<rt data-v-66111b90>ばあい</rt></ruby>は、<ruby data-v-66111b90>正<rt data-v-66111b90>ただ</rt></ruby>しい<ruby data-v-66111b90>番号<rt data-v-66111b90>ばんごう</rt></ruby>の○を<ruby data-v-66111b90>押<rt data-v-66111b90>お</rt></ruby>しなおしてください。</p><p data-v-66111b90>それぞれの<ruby data-v-66111b90>問題<rt data-v-66111b90>もんだい</rt></ruby>の<ruby data-v-66111b90>解答<rt data-v-66111b90>かいとう</rt></ruby><ruby data-v-66111b90>時間<rt data-v-66111b90>じかん</rt></ruby>が<ruby data-v-66111b90>終<rt data-v-66111b90>お</rt></ruby>わったら、ピンポンという<ruby data-v-66111b90>音<rt data-v-66111b90>おと</rt></ruby>が<ruby data-v-66111b90>鳴<rt data-v-66111b90>な</rt></ruby>ります。</p><p data-v-66111b90>この<ruby data-v-66111b90>音<rt data-v-66111b90>おと</rt></ruby>は、<ruby data-v-66111b90>次<rt data-v-66111b90>つぎ</rt></ruby>の<ruby data-v-66111b90>問題<rt data-v-66111b90>もんだい</rt></ruby>にすすむという<ruby data-v-66111b90>合図<rt data-v-66111b90>あいず</rt></ruby>です。</p><p data-v-66111b90></p><p data-v-66111b90><ruby data-v-66111b90>問題<rt data-v-66111b90>もんだい</rt></ruby>は、それぞれ2<ruby data-v-66111b90>回<rt data-v-66111b90>かい</rt></ruby>ずつ<ruby data-v-66111b90>繰<rt data-v-66111b90>く</rt></ruby>り<ruby data-v-66111b90>返<rt data-v-66111b90>かえ</rt></ruby>して<ruby data-v-66111b90>読<rt data-v-66111b90>よ</rt></ruby>みます。</p><p data-v-66111b90>それでは、リスニング<ruby data-v-66111b90>問題<rt data-v-66111b90>もんだい</rt></ruby>を<ruby data-v-66111b90>始<rt data-v-66111b90>はじ</rt></ruby>めます。</p>", 9)

import {inject, ref} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { appKey, examKey } from "@/main";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Caution',
  emits: ['overridePageName'],
  setup(__props) {

const app = inject(appKey);
const exam = inject(examKey);


const route = useRoute();
const router = useRouter();

const group = route.params.group;
const baseUrl = exam?.getAudioUrl();
const currentPage = ref(1);
const rank = ref<string>('');
const gakken = exam?.isGakken();

const next = async() => {
  try {
    await exam?.listeningStart();
    router.replace(`/cbt/${group}/listening/0/flow`);
  } catch (e) {
    alert(e.message);
    router.replace(`/cbt/${group}/login`);
  }
}

const playCaution = async () => {
  app?.playAudioUrl(baseUrl + 'caution.m4a', false, async () => {
    if (!gakken) {
      await playCautionTeacher();
    }
    else {
      await playCautionRank();
    }
  });
}

const playCautionTeacher= async () => {
  app?.playAudioUrl(baseUrl + 'caution_teacher.m4a', false, async() => {
    await playCautionRank();
  });
}

const playCautionRank = async () => {
  currentPage.value = 2;
  app?.playAudioUrl(baseUrl + 'caution_' + rank.value +  '.m4a', false, async() => {
    if (!gakken) {
      await playCaution2Teacher();
    }
    else {
      await playCaution2();
    }
  });
}

const playCaution2Teacher = async () => {
  app?.playAudioUrl(baseUrl + 'caution2_teacher.m4a', false, async () => {
    await playCaution2();
  });
}

const playCaution2 = async () => {
  app?.playAudioUrl(baseUrl + 'caution2_body.m4a', false, async () => {
    await next();
  });
}

const init = async() => {
  if (!exam) return;
  rank.value = (await exam.questions()).rank;
  await playCaution();
}
init();

const demoPrev = () => {
  app?.stopAudio();
  if (currentPage.value === 1) {
    router.replace(`/cbt/${group}/exam-start`);
  } else {
    currentPage.value = 1;
    playCaution();
  }
}
const demoNext = () => {
  app?.stopAudio();
  if (currentPage.value === 1) {
    playCautionRank();
  } else {
    router.replace(`/cbt/${group}/listening/0/flow`);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "m-logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(exam).isDebug() && next()))
    }, _hoisted_2),
    (currentPage.value === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (!_unref(gakken))
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _createTextVNode("テストが"),
                    _hoisted_10,
                    _createTextVNode("わったら、"),
                    _hoisted_11,
                    _createTextVNode("がよいと"),
                    _hoisted_12,
                    _createTextVNode("うまで、"),
                    _hoisted_13,
                    _createTextVNode("に"),
                    _hoisted_14,
                    _createTextVNode("ったまま"),
                    _hoisted_15,
                    _createTextVNode("かに"),
                    _hoisted_16,
                    _createTextVNode("ちましょう。")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (currentPage.value === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", null, [
                _hoisted_19,
                _createTextVNode("から、JET "),
                _hoisted_20,
                _createTextVNode("テストの" + _toDisplayString(rank.value), 1),
                _hoisted_21,
                _createTextVNode("を"),
                _hoisted_22,
                _createTextVNode("めます。")
              ]),
              _hoisted_23,
              (rank.value === '1-2')
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                    _createTextVNode("このテストは、Part 1からPart 5までが、"),
                    _hoisted_25,
                    _createTextVNode("を"),
                    _hoisted_26,
                    _createTextVNode("いて"),
                    _hoisted_27,
                    _createTextVNode("えるリスニング"),
                    _hoisted_28,
                    _createTextVNode("で、Part 6からPart 8までは、"),
                    _hoisted_29,
                    _createTextVNode("を"),
                    _hoisted_30,
                    _createTextVNode("んで"),
                    _hoisted_31,
                    _createTextVNode("えるリーディング"),
                    _hoisted_32,
                    _createTextVNode("です。")
                  ]))
                : _createCommentVNode("", true),
              (rank.value === '3-4')
                ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                    _createTextVNode("このテストは、Part 1からPart 5までが、"),
                    _hoisted_34,
                    _createTextVNode("を"),
                    _hoisted_35,
                    _createTextVNode("いて"),
                    _hoisted_36,
                    _createTextVNode("えるリスニング"),
                    _hoisted_37,
                    _createTextVNode("で、Part 6からPart 8までは、"),
                    _hoisted_38,
                    _createTextVNode("を"),
                    _hoisted_39,
                    _createTextVNode("んで"),
                    _hoisted_40,
                    _createTextVNode("えるリーディング"),
                    _hoisted_41,
                    _createTextVNode("です。")
                  ]))
                : _createCommentVNode("", true),
              (rank.value === '5-6')
                ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                    _createTextVNode("このテストは、Part 1からPart 5までが、"),
                    _hoisted_43,
                    _createTextVNode("を"),
                    _hoisted_44,
                    _createTextVNode("いて"),
                    _hoisted_45,
                    _createTextVNode("えるリスニング"),
                    _hoisted_46,
                    _createTextVNode("で、Part 6とPart 7は、"),
                    _hoisted_47,
                    _createTextVNode("を"),
                    _hoisted_48,
                    _createTextVNode("んで"),
                    _hoisted_49,
                    _createTextVNode("えるリーディング"),
                    _hoisted_50,
                    _createTextVNode("です。")
                  ]))
                : _createCommentVNode("", true),
              (rank.value === '7-8')
                ? (_openBlock(), _createElementBlock("p", _hoisted_51, [
                    _createTextVNode("このテストは、Part 1からPart 6までが、"),
                    _hoisted_52,
                    _createTextVNode("を"),
                    _hoisted_53,
                    _createTextVNode("いて"),
                    _hoisted_54,
                    _createTextVNode("えるリスニング"),
                    _hoisted_55,
                    _createTextVNode("で、Part 7は、"),
                    _hoisted_56,
                    _createTextVNode("を"),
                    _hoisted_57,
                    _createTextVNode("んで"),
                    _hoisted_58,
                    _createTextVNode("えるリーディング"),
                    _hoisted_59,
                    _createTextVNode("です。")
                  ]))
                : _createCommentVNode("", true),
              (rank.value === '9-10')
                ? (_openBlock(), _createElementBlock("p", _hoisted_60, [
                    _createTextVNode("このテストは、Part 1からPart 6まですべて、"),
                    _hoisted_61,
                    _createTextVNode("を"),
                    _hoisted_62,
                    _createTextVNode("いて"),
                    _hoisted_63,
                    _createTextVNode("えるリスニング"),
                    _hoisted_64,
                    _createTextVNode("です。")
                  ]))
                : _createCommentVNode("", true),
              (!_unref(gakken))
                ? (_openBlock(), _createElementBlock("p", _hoisted_65, [
                    _createTextVNode("みんなが"),
                    _hoisted_66,
                    _createTextVNode("を"),
                    _hoisted_67,
                    _createTextVNode("しく"),
                    _hoisted_68,
                    _createTextVNode("き"),
                    _hoisted_69,
                    _createTextVNode("れるように、テスト"),
                    _hoisted_70,
                    _createTextVNode("は"),
                    _hoisted_71,
                    _createTextVNode("かにしてください。")
                  ]))
                : _createCommentVNode("", true),
              _hoisted_72
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext
    })
  ], 64))
}
}

})